import { css } from '@emotion/react'

export default css`
	align-items: center;
	display: flex;
`;
